import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ name: '',description: '', icon: '📁', color: '#6C63FF' });

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const { data } = await api.get('/categories');
    setCategories(data.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await api.put(`/categories/${editId}`, formData);
        toast.success('Category updated');
      } else {
        console.log(formData);
       const response= await api.post('/categories', formData);
       console.log(response);
        toast.success('Category created');
      }
      setShowModal(false);
      setEditId(null);
      setFormData({ name: '',  description: '', icon: '📁', color: '#6C63FF' });
      fetchCategories();
    } catch (error) {
      toast.error('Error saving category');
    }
  };

  const handleEdit = (cat) => {
    setFormData(cat);
    setEditId(cat.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete category?')) return;
    try {
      await api.delete(`/categories/${id}`);
      toast.success('Category deleted');
      fetchCategories();
    } catch (error) {
      toast.error('Error deleting category');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold mb-2">Categories</h1>
          <p className="text-gray-400">Manage game categories</p>
        </div>
        <button onClick={() => { setShowModal(true); setEditId(null); setFormData({ name: '', description: '', icon: '📁', color: '#6C63FF' }); }}
          className="flex items-center gap-2 px-6 py-3 gradient-primary text-white font-semibold rounded-lg">
          <Plus size={20} /> Add Category
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map(cat => (
          <div key={cat.id} className="gradient-card border border-gray-800 rounded-xl p-6">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="text-4xl">{cat.icon}</div>
                <div>
                  <h3 className="font-bold text-lg">{cat.name}</h3>
                 
                </div>
              </div>
              <div style={{ backgroundColor: cat.color }} className="w-4 h-4 rounded-full"></div>
            </div>
            <p className="text-sm text-gray-400 mb-4">{cat.gameCount || 0} games</p>
            <div className="flex gap-2">
              <button onClick={() => handleEdit(cat)} className="flex-1 py-2 bg-primary/20 text-primary rounded-lg hover:bg-primary/30">
                <Edit size={16} className="inline mr-1" /> Edit
              </button>
              <button onClick={() => handleDelete(cat.id)} className="py-2 px-4 bg-red-500/20 text-red-500 rounded-lg hover:bg-red-500/30">
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-dark-card border border-gray-800 rounded-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">{editId ? 'Edit' : 'Add'} Category</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="text" placeholder="Name" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
              <textarea 
               rows={4}
              placeholder="Description" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})}
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white" />
              <div className="grid grid-cols-2 gap-4">
                <input type="text" placeholder="Icon" value={formData.icon} onChange={e => setFormData({...formData, icon: e.target.value})}
                  className="px-4 py-3 bg-dark border border-gray-700 rounded-lg focus:outline-none focus:border-primary text-white text-center text-2xl" />
                <input type="color" value={formData.color} onChange={e => setFormData({...formData, color: e.target.value})}
                  className="w-full h-12 bg-dark border border-gray-700 rounded-lg cursor-pointer" />
              </div>
              <div className="flex gap-4">
                <button type="submit" className="flex-1 py-3 gradient-primary text-white rounded-lg">Save</button>
                <button type="button" onClick={() => setShowModal(false)} className="px-6 py-3 bg-gray-800 text-white rounded-lg">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Categories;
